import { TestUser } from '@models/TestUser'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { TEST_USERS_URL } from '@utils/urls'

const fetchTestUsers = (params: TableParams) =>
  SBAPI.FetchPaginated<TestUser[]>(TEST_USERS_URL, params)

const fetchTestUserById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<TestUser>(`${TEST_USERS_URL}/${id}`, params)

const createTestUser = (data: { email: string }) =>
  SBAPI.Post(TEST_USERS_URL, data)

const deleteTestUser = (testUser: number) =>
  SBAPI.Delete(`${TEST_USERS_URL}/${testUser}`)

export { createTestUser, deleteTestUser, fetchTestUserById, fetchTestUsers }
